import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DatabaseIcon = () => {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": true,
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "10",
      cy: "10",
      r: "10",
      fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.9584 8.18046V10C14.9584 10.978 12.7384 11.7708 10 11.7708C7.26161 11.7708 5.04169 10.978 5.04169 10V8.18046C5.36857 8.39765 5.74597 8.57159 6.13659 8.7111C7.17597 9.08231 8.542 9.29167 10 9.29167C11.458 9.29167 12.8241 9.08231 13.8634 8.7111C14.2541 8.57159 14.6315 8.39765 14.9584 8.18046Z",
      fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.9584 6.45833C14.9584 5.48033 12.7384 4.6875 10 4.6875C7.26161 4.6875 5.04169 5.48033 5.04169 6.45833C5.04169 7.43634 7.26161 8.22917 10 8.22917C12.7384 8.22917 14.9584 7.43634 14.9584 6.45833Z",
      fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.04169 11.7221V13.1875C5.04169 14.1655 7.26161 14.9583 10 14.9583C12.7384 14.9583 14.9584 14.1655 14.9584 13.1875V11.7221C14.6315 11.9393 14.2541 12.1133 13.8634 12.2528C12.8241 12.624 11.458 12.8333 10 12.8333C8.542 12.8333 7.17597 12.624 6.13659 12.2528C5.74597 12.1133 5.36857 11.9393 5.04169 11.7221Z",
      fill: "var(--ds-icon-inverse, #FFFFFF)"
    })]
  });
};